<template>
    <section>
        <o-field>
            <o-checkbox :model-value="true" size="small" label="Small" />
        </o-field>

        <o-field>
            <o-checkbox :model-value="true" label="Default" />
        </o-field>

        <o-field>
            <o-checkbox :model-value="true" size="medium" label="Medium" />
        </o-field>

        <o-field>
            <o-checkbox :model-value="true" size="large" label="Large" />
        </o-field>
    </section>
</template>
